import React from 'react';
import { Paper } from '@mui/material';
import { UserProfile } from './UserProfile';

export const UserProfileTab: React.FC = () => (
  <Paper elevation={2}>
    <UserProfile />
  </Paper>
);
